


























import { Component, Vue } from 'vue-property-decorator'
import { MENSAGEM_TAMANHO_MAXIMO_NOTA_FISCAL, notaFiscalExcedeTamanhoMaximo } from '@/utils/notaFiscal'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import _ from 'lodash'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'

@Component
export default class ViewFinanceiroUploadNotaFiscal extends Vue {
  inputFiles: any[] = []
  loadAnexo: boolean = false

  get loadingAnexo() {
    return this.loadAnexo
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async inputFile(newFile) {
    if (!newFile || newFile.identifier) {
      return
    }

    if (notaFiscalExcedeTamanhoMaximo(newFile.file)) {
      EventBus.$emit('setSnackbar', { show: true, text: MENSAGEM_TAMANHO_MAXIMO_NOTA_FISCAL, icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingAnexo = true

    const formData = new FormData()
    formData.append('notaFiscal', newFile.file)

    const params: any = {
      formData,
      prestadorRecebimentoId: this.$route.params.prestadorRecebimentoId,
    }

    const response = await this.getFinanceiroStore.uploadNotaFiscal(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Arquivo enviado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: this.errorsMessage(response) || 'Houve um problema ao enviar o arquivo.', icon: 'warning', color: '#C62828' })
    }

    this.loadingAnexo = false
  }

  errorsMessage(mensagens: any) {
    // eslint-disable-next-line
    return mensagens.errors.reduce((target, source) => { target += source.message; return target }, '')
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
  }

  mounted() {
    this.deleteAllCookies()
    localStorage.clear()
  }

  // beforeDestroy() {
  //   this.$router.go(-1)
  // }
}
